module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowBold.e10313a.woff2";